// File: src/components/FormPreview/FormPreviewSkeleton.jsx

import React from "react";
import { Box, Skeleton } from "@mui/material";

/**
 * A simple skeleton that mimics a form preview
 * with 2 text fields and a submit button.
 */
const FormPreviewSkeleton = () => {
  return (
    <Box sx={{ p: 2 }}>
      {/* Title or heading skeleton */}
      <Skeleton variant="text" width="60%" height={32} sx={{ mb: 3 }} />
      
      {/* First field skeleton */}
      <Skeleton variant="rectangular" width="100%" height={56} sx={{ mb: 2 }} />
      
      {/* Second field skeleton */}
      <Skeleton variant="rectangular" width="100%" height={56} sx={{ mb: 2 }} />
      
      {/* Button skeleton */}
      <Skeleton
        variant="rectangular"
        width={120}
        height={48}
        sx={{ mt: 2, mx: "auto" }}
      />
    </Box>
  );
};

export default FormPreviewSkeleton;
